import { makeStyles } from '@material-ui/core/styles';
import React from 'react';
import SelectArticles from '../../organisms/Newsletter/select_articles';

const useStyles = makeStyles((theme) => ({
  container: {
    display: 'flex',
    flexDirection: 'column',
    flex: 1
  }
}));

const Newsletter = () => {
  const classes = useStyles();

  return (
    <div className={classes.container}>
      <SelectArticles />
    </div>
  );
}

export default Newsletter;